<div
    id="attributeViewer"
    class="widget container-fluid well"
    cdkDrag
    [cdkDragConstrainPosition]="computeDragPosition">
    <form
        id="attributeViewerForm"
        name="form"
        novalidate
        autocomplete="off">
        <div
            class="col-xs-12 widget-header"
            cdkDragHandle>
            <span>{{widgetConfig.header}}</span>

            <div class="pull-right btn-group btn-group-xs">
                <nlrp-help-link
                    [url]="helpLinkUrl"
                    [pageTitle]="helpPageTitle"></nlrp-help-link>

                <i
                    class="nlrp-icon nlrp-18"
                    [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                    title="{{open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip}}"
                    (click)="showOrHide()">
                </i>

                <i
                    class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                    title="{{widgetConfig.closeTooltip}}"
                    id="closeAttributeBtn"
                    (click)="onClose()"></i>
            </div>
        </div>
        <div
            class="widget-content"
            [hidden]="!open"
            [ngClass]="{'disabled-cursor': isDisabled()}">
            <div class="col-xs-12">
                <h6>{{widgetConfig.subHeader}}</h6>
            </div>

            <div class="col-xs-12">
                <!-- Nav tabs -->
                <ul
                    class="nav nav-tabs"
                    role="tablist">
                    <li
                        role="presentation"
                        class="active"
                        [ngClass]="{'disabled': isTabDisabled('geometryTab')}">
                        <a
                            href
                            id="geometryBtn"
                            role="tab"
                            data-target="#geometryTab"
                            data-toggle="tab"
                            (click)="onClickTab('geometryTab')">
                            Geometry
                        </a>
                    </li>
                    <li
                        role="presentation"
                        [ngClass]="{'disabled': isTabDisabled('surveyTab')}">
                        <a
                            href
                            id="surveyBtn"
                            role="tab"
                            data-target="#surveyTab"
                            data-toggle="tab"
                            (click)="onClickTab('surveyTab')">
                            Survey
                        </a>
                    </li>
                </ul>
                <!-- Tab panes -->
                <div class="tab-content">
                    @if (activeTab === 'geometryTab') {
                        <nlr-geometry-tab
                            id="geometryTab"
                            role="tabpanel"
                            class="tab-pane active"
                            [disabled]="isDisabled()"
                            [selectedTab]="selectedTab"
                            [editorConfig]="editorConfig">
                        </nlr-geometry-tab>
                    }

                    @if (activeTab === 'surveyTab') {
                        <nlr-survey-tab
                            id="surveyTab"
                            role="tabpanel"
                            class="tab-pane"
                            [disabled]="isDisabled()"
                            [selectedTab]="selectedTab"
                            [editorConfig]="editorConfig">
                        </nlr-survey-tab>
                    }
                </div>
            </div>
        </div>
    </form>
</div>
<div id="attributeViewerOverlayContainer"></div>
